import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { BsQrCodeScan } from "react-icons/bs";
import { MdAutorenew } from "react-icons/md";
import Preview from "../components/Preview.js";
import axios from "axios";

export default function Employers(props) {
  const token = useSelector((state) => state.auth.token);
  const { chooseSapId, show, onHide } = props;

  const [isError, setIsError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingQr, setIsLoadingQr] = useState(false);
  const [imageSrc, setImageSrc] = useState("");
  const [preview, setPreview] = useState(false);
  const [file, setFile] = useState("");
  const form = useRef(null);

  const fetchQRCode = async () => {
    setIsLoadingQr(true);
    if (!chooseSapId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}employee/qr/${chooseSapId}`,
        {
          headers: { Authorization: `bearer ${token}` },
        }
      );
      const base64Image = `data:image/png;base64,${response?.data}`;
      if (response?.data) {
        setImageSrc(base64Image);
      }
      setPreview(true);
      setIsLoadingQr(false);
    } catch (error) {
      console.error("QR kod yüklənərkən xəta baş verdi:", error);
    }
  };

  const onPostGroup = () => {
    setIsLoading(true);
    axios
      .post(
        `${process.env.REACT_APP_API_URL}employee/qr/${chooseSapId}`,
        {},
        {
          headers: { Authorization: `bearer ${token}` },
        }
      )
      .then(() => {
        fetchQRCode();
        setPreview(false);
        setImageSrc("");
        setFile("");
        setIsLoading(false);
      })
      .catch((err) => {
        let message = err.response?.data?.message || err.message;
        setIsError(message);
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (show) {
      setIsError("");
      fetchQRCode();
    }
  }, [show, chooseSapId]);

  const onHideModal = () => {
    setImageSrc("");
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHideModal}
      size="xl"
      aria-labelledby="edit"
      centered
      className="pr-0"
    >
      <form ref={form}>
        <Modal.Header closeButton>
          <Modal.Title id="delete">
            İnsan resurslarının QR kodu -{chooseSapId}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row bg-white rounded">
            <div className="col-12">
              <div className="w-100 pt-2 pb-3 d-flex flex-column justify-content-center align-items-center">
                <button
                  variant="contained"
                  type="button"
                  component="span"
                  className="qr_generate_btn btn-success mb-4"
                  onClick={onPostGroup}
                >
                  <MdAutorenew
                    style={{ fontSize: "18px", marginRight: "6px" }}
                  />
                  Yeni QR
                </button>
                <div>
                  {isLoading || isLoadingQr ? (
                    <div className="mt-5">
                      {" "}
                      <span className=" spinner spinner-success "></span>{" "}
                    </div>
                  ) : (
                    <div className="image-preview-qr">
                      {imageSrc && <img src={imageSrc} alt="img" />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="light" onClick={() => onHide(false)}>
            Bağla
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
